import { createIcon } from '@chakra-ui/react';

export const ChevronLeftGhostIcon = createIcon({
  displayName: 'ChevronLeftGhostIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="12"
        // height="12"
        viewBox="0 0 12 12"
        fill="none"
      >
        <path
          d="M7.54492 9.96001L4.28492 6.70001C3.89992 6.31501 3.89992 5.68501 4.28492 5.30001L7.54492 2.04001"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  ),
});
